function handleSkipLink() {
  const skipLink = document.querySelector('[href="#main-content"]');
  const mainContent = document.querySelector('#main-content');

  if (!skipLink || !mainContent) return;

  skipLink.addEventListener('click', (e) => {
    e.preventDefault();
    mainContent.focus();
  });
}

window.addEventListener('load', handleSkipLink);
